import * as React from 'react';

export interface IAccordionProps {
  children: {};
}

const Accordion = ({ children }: IAccordionProps) => (
  <div className="accordion">{children}</div>
);

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/Accordion/index.tsx